<script>
    export default {
        name: 'bread-crumb-item',
        props: {
            to: {},
            toName: {},
            replace: Boolean
        },
        inject: ['breadCrumb'],
        data () {
            return {
                separatorIcon: ''
            };
        },
        watch: {},
        methods: {
            gotoPath () {
                const {to, replace, toName, $router} = this;
                replace ? $router.replace(to ? {path: to} : {name: toName}) : $router.push(to ? {path: to} : {name: toName});
            }
        },
        mounted () {
            this.separatorIcon = this.breadCrumb.separatorIcon;
        }
    };
</script>

<template>
    <div class="path-pair" @click="gotoPath()">
        <span><slot></slot></span>
        <i class="icon" v-html="separatorIcon"></i>
    </div>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .icon {
        font-family: cmsicon;
        font-style: normal;
        font-size: 12px;
        margin: 0 6px;
    }

    .path-pair {
        line-height: 36px;
        height: 36px;
        font-size: 14px;

        span {
            cursor: pointer;
        }

        &:first-child {
            > span {
                font-weight: 700;
                text-decoration: none;
                transition: color .2s cubic-bezier(.645, .045, .355, 1);
            }
        }

        &:last-child {
            .icon {
                display: none;
            }
        }


        &:hover {
            color: @primaryActiveBg;
        }

        &.disabled {
            color: @otherIptSelTipsDisbaledClr;
        }
    }
</style>
